import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
const DropdownContext = createContext(null);
export const DropdownContextProvider = ({ children }) => {
    const [isShown, setIsShown] = useState(false);
    const close = useCallbackRef(() => {
        setIsShown(false);
    });
    const update = useCallbackRef((value) => {
        setIsShown(value);
    });
    const value = useMemo(() => ({ isShown, close, update }), [isShown, close, update]);
    return _jsx(DropdownContext.Provider, { value: value, children: children });
};
export const useDropdownContext = () => {
    const ctx = useContext(DropdownContext);
    if (!ctx) {
        throw new Error('useDropdownContext must be used within DropdownContextProvider');
    }
    return ctx;
};
